module.exports = __webpack_public_path__ + "img/developers--icon.3e98af83.svg";